module.exports = __webpack_public_path__ + "../resources/img/bg_inventory.a46b31c5.png";